import React, { FunctionComponent, SVGAttributes } from 'react';
import { Svg } from '../../SvgOptimizer/Svg';

const Outline: FunctionComponent<SVGAttributes<SVGSVGElement>> = (props) => (
  <Svg optimizationId="iconsArrowForwardOutline" viewBox="0 0 24 24" {...props}>
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
  </Svg>
);

Outline.displayName = 'ArrowForwardOutline';

export default Outline;
